import CourseInfo from './../../coursesAndOffers/components/CourseInfo';
import { useVoucherRedeem } from '../hooks/useVoucherRedeem';
import { useNavigate } from 'react-router-dom';
import { Spinner, user } from '@nextui-org/react';
import { useCourses } from './../../coursesAndOffers/hooks/useCourses';
import { useUserLectures } from '../../userProfile/userLectures/hooks/useUserLectures';
import { useMemo } from 'react';
import Button from '../../../../components/Button';

function LectureItem({ lecture, code }) {
    const navigate = useNavigate();
    const {
        id,
        attributes: { name, brief, courseId },
    } = lecture;

    const { voucherRedeem } = useVoucherRedeem();
    const { userLectures, isPending: isLecturesPending } = useUserLectures();
    const { courses, isPending } = useCourses({
        filter: { field: 'id', value: courseId },
    });

    const isOwnedLecture = useMemo(() => {
        if (!lecture && !userLectures) return
        return userLectures?.data?.some((lec) => lec.id === lecture.id);
    }, [userLectures, lecture]);

    if (isPending || isLecturesPending) {
        return (
            <div className="p-5 mx-auto">
                <Spinner color="primary" />
            </div>
        );
    }

    const grade = courses?.data[0]?.attributes?.grade;

    function onSubmit() {
        if (!code) return;

        voucherRedeem(
            { voucher: code, lecture_id: id },
            {
                onSuccess: () => {
                    navigate(`/${grade}/courses/${courseId}/lectures/${id}`);
                },
            }
        );
    }

    return (
        <div className="flex flex-col items-center justify-between w-full gap-10 p-10 rounded-lg lg:flex-row bg-background-color">
            {/* img */}
            <div className="w-100">
                <img
                    src="/images/courses/courseImage.webp"
                    alt="course icon"
                    className="w-100"
                    loading="lazy"
                    decoding="async"
                />
            </div>

            <div className="flex flex-col items-center justify-between w-full gap-3 text-center lg:flex-row">
                <CourseInfo name={name} brief={brief} maxName={10} maxBrief={30} />

                {code ? (
                    isOwnedLecture ? (
                        <div>
                            <div className='hidden md:block'>

                                <Button
                                    link1={`/${grade}/courses/${courseId}/lectures/${id}`}
                                    link1Name="الدخول للمحاضرة"
                                    onClick={onSubmit}
                                    link2Name="زياده عدد المشاهدات"
                                    name="redeem lecture with code"
                                    type="primary"
                                />
                            </div>
                            <div className='flex flex-col gap-2 md:hidden'>
                                <Button
                                    name="redeem lecture with code"
                                    onClick={onSubmit}
                                    type="primary"
                                >
                                    زياده عدد المشاهدات
                                </Button>
                                <Button
                                    name="go to lecture"
                                    onClick={() =>
                                        navigate(`/${grade}/courses/${courseId}/lectures/${id}`)
                                    }
                                    type="primary"
                                >
                                    الدخول للمحاضرة
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <Button
                            name="buy lecture with voucher"
                            onClick={onSubmit}
                            type="primary"
                        >
                            شراء
                        </Button>
                    )
                ) : isOwnedLecture ? (
                    <Button
                        name="go to lecture"
                        onClick={() =>
                            navigate(`/${grade}/courses/${courseId}/lectures/${id}`)
                        }
                        type="primary"
                    >
                        الدخول للمحاضرة
                    </Button>
                ) : (
                    <Button type="disabled">غير متاح</Button>
                )}
            </div>
        </div>
    );
}

export default LectureItem;
